import { defineConfig } from '../defineConfig';

export function createProdConfig() {
  return defineConfig({
    env: 'production',
    apiURL: import.meta.env.VITE_API_URL! as string,
  });
}
